import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DFPSlotsProvider, DFPManager, AdSlot } from 'react-dfp';
import clientConfig from '../../../clientConfig';
import { getDynamicAdUnitPath } from '../../../utils/advertising/getDynamicAdUnitPath';
import './Advertising.scss';

/*
 * white label
 */
export class Advertising extends Component {
  constructor(props) {
    super(props);

    const { advSize } = this.props;

    this.currentAdv = clientConfig.advertising[advSize];
  }

  advRefresh = () => {
    const currentWidth = window.innerWidth;

    this.currentAdv.sizeMapping.forEach((item) => {
      const viewport = item.viewport[0];
      const isVertexCrossing =
        Math.sign(viewport - currentWidth) !==
        Math.sign(viewport - this.lastWidth);

      if (viewport && isVertexCrossing) {
        this.lastWidth = currentWidth;
        DFPManager.refresh(this.props.advSlots);
      }
    });
  };

  componentDidMount() {
    const {
      enabled,
      options: { data: { advertisingEnabled = false } = {} } = {},
    } = this.props;

    if (advertisingEnabled && enabled && this.currentAdv.sizes.length > 1) {
      this.lastWidth = window.innerWidth;
      window.addEventListener('resize', this.advRefresh);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.advRefresh);
  }

  render() {
    const {
      advSlots,
      options: {
        data: { advertisingEnabled = false, networkId, adUnit } = {},
      } = {},
      pageCategory = '',
      style,
      enabled,
    } = this.props;
    const adUnitPath = getDynamicAdUnitPath({ adUnit, pageCategory });

    return (
      advertisingEnabled &&
      enabled && (
        <div className="c-advertising" style={style}>
          <DFPSlotsProvider dfpNetworkId={networkId} collapseEmptyDivs>
            {advSlots.map((advSlot, i) => (
              <AdSlot
                key={i}
                adUnit={adUnitPath}
                sizes={this.currentAdv.sizes}
                sizeMapping={this.currentAdv.sizeMapping}
                slotId={advSlot.slotId}
                targetingArguments={{
                  pos: advSlot.target || advSlot.slotId,
                }}
              />
            ))}
          </DFPSlotsProvider>
        </div>
      )
    );
  }
}

Advertising.defaultProps = {
  enabled: true,
};

Advertising.propTypes = {
  options: PropTypes.object,
  pageCategory: PropTypes.string,
  advSlots: PropTypes.array,
  advSize: PropTypes.string,
  style: PropTypes.object,
  enabled: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    options: state.options,
  };
}

export default connect(mapStateToProps)(Advertising);
